export enum TipoPersonaEnum {
    PersonaNatural = 1,
    PersonaJuridica = 2
}